const STORAGE_KEY = "bookdental:pendingConnectInvite";

export type ConnectInviteKind = "partner" | "lab" | "catalogo";

/** `catalogo`: o token é o código do link público do laboratório; `linha` ("serviço:material")
 *  quando veio do "Pedir" de uma linha. */
export type PendingConnectInvite = { kind: ConnectInviteKind; token: string; linha?: string };

/**
 * Lê o parâmetro `?connectInvite=partner:TOKEN` ou `lab:TOKEN` deixado na URL pelo redirect do
 * apps/web (tela /conectar-dentista ou /conectar-laboratorio) após signup/login, e persiste em
 * localStorage — sobrevive aos passos do onboarding e a reloads, até ser consumido por
 * `PendingConnectInviteBanner`. Sem isso o usuário precisaria lembrar de voltar sozinho no link
 * do convite depois de completar o cadastro.
 */
export function captureConnectInviteParam() {
  const params = new URLSearchParams(window.location.search);
  // Link público do catálogo: `?catalogo=CÓDIGO` (e `&linha=SERVIÇO:MATERIAL` vindo do "Pedir").
  const catalogo = params.get("catalogo");
  if (catalogo) {
    const linha = params.get("linha");
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ kind: "catalogo", token: catalogo, ...(linha ? { linha } : {}) }));
    params.delete("catalogo");
    params.delete("linha");
    const query = params.toString();
    window.history.replaceState(null, "", window.location.pathname + (query ? `?${query}` : "") + window.location.hash);
  }
  const raw = params.get("connectInvite");
  if (raw) {
    const [kind, token] = raw.split(":");
    if ((kind === "partner" || kind === "lab") && token) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ kind, token }));
    }
    params.delete("connectInvite");
    const query = params.toString();
    const url = window.location.pathname + (query ? `?${query}` : "") + window.location.hash;
    window.history.replaceState(null, "", url);
  }
}

export function getPendingConnectInvite(): PendingConnectInvite | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed?.kind && parsed?.token) return parsed;
  } catch {
    // localStorage corrompido/formato antigo — ignora
  }
  return null;
}

export function clearPendingConnectInvite() {
  localStorage.removeItem(STORAGE_KEY);
}
